// removed by extract-text-webpack-plugin
module.exports = {"menuText":"#919399","menuActiveText":"#6aa1ed","menuActiveBg":"#eef6fe","subMenuActiveText":"#6aa1ed","menuBg":"#fff","menuHover":"#eef6fe","subMenuBg":"#fff","subMenuHover":"#eef6fe","sideBarWidth":"220px"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/index.scss
// module id = yh13
// module chunks = 8